import { SIZE, Pagination as RawPagination } from 'baseui/pagination';
import { PaginationMeta } from 'common/repositories/common.model';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import {
  PaginationContainer,
  PaginationHighlightText,
  PaginationSectionContainer,
  PaginationText,
} from './styles';

export interface PaginationProps {
  page: number;
  onPageChange: (page: number) => void;
  meta: PaginationMeta | undefined;
}

export function Pagination(props: {
  numPages: number;
  currentPage: number;
  onPageChange: (nextPage: number) => void;
}) {
  const { numPages, onPageChange, currentPage } = props;

  return (
    <RawPagination
      size={SIZE.mini}
      overrides={{
        MaxLabel: {
          style: {
            fontSize: '12px',
          },
        },
        Select: {
          props: {
            overrides: {
              Popover: {
                props: {
                  overrides: {
                    Body: {
                      style: {
                        zIndex: 100,
                      },
                    },
                  },
                },
              },
            },
          },
        },
      }}
      numPages={numPages}
      currentPage={currentPage}
      onPageChange={({ nextPage }) => {
        onPageChange(Math.min(Math.max(nextPage, 1), numPages));
      }}
    />
  );
}

export default function PaginationComponent(props: PaginationProps) {
  const { page, onPageChange, meta } = props;
  const { t } = useTranslation();
  if (!meta) {
    return null;
  }

  if (!meta.total) {
    return null;
  }

  return (
    <PaginationContainer>
      <PaginationSectionContainer>
        <PaginationText>
          {`${t('common:show')} `}
          <PaginationHighlightText>
            {`${meta?.from || 0}-${meta?.to || 0} `}
          </PaginationHighlightText>
          {t('common:of_total_items', { total: meta.total })}
        </PaginationText>
      </PaginationSectionContainer>

      <PaginationSectionContainer>
        <Pagination
          numPages={meta.lastPage}
          currentPage={page}
          onPageChange={onPageChange}
        />
      </PaginationSectionContainer>

      <PaginationSectionContainer $style={hiddenSection}>
        <PaginationText $style={{ opacity: 0 }}>
          {`${t('common:show')} `}
          <PaginationHighlightText>
            {`${meta?.from || 0}-${meta?.to || 0} `}
          </PaginationHighlightText>
          {t('common:of_total_items', { total: meta.total })}
        </PaginationText>
      </PaginationSectionContainer>
    </PaginationContainer>
  );
}

const hiddenSection: StyleObject | any = {
  display: 'none',
  '@media screen and (min-width: 992px)': {
    display: 'flex',
  },
};
